import {
  EmbeddedViewRef,
  EnvironmentInjector,
  Injectable,
  NgZone,
  createComponent,
} from '@angular/core';
import { ToastType } from '../../toast-types';
import * as bootstrap from 'bootstrap';
import { ToastV2Component } from '../components/toast/toast.component';

@Injectable({ providedIn: 'root' })
export class ToastV2Service {
  constructor(
    private environmentInjector: EnvironmentInjector,
    private zone: NgZone,
  ) {}

  public success(message?: string, autohide?: boolean) {
    return this.show(ToastType.Success, message, autohide);
  }

  public warning(message?: string, autohide?: boolean) {
    return this.show(ToastType.Warning, message, autohide);
  }

  public error(message?: string, autohide?: boolean) {
    return this.show(ToastType.Error, message, autohide);
  }

  public info(message?: string, autohide?: boolean) {
    return this.show(ToastType.Info, message, autohide);
  }

  private show(type: ToastType, message?: string, autohide = true) {
    //create a component reference
    const componentRef = createComponent(ToastV2Component, {
      environmentInjector: this.environmentInjector,
    });

    componentRef.instance.type = type;
    componentRef.instance.messageKey = message;
    componentRef.changeDetectorRef.detectChanges();

    // get DOM element from component
    const domElem = (componentRef.hostView as EmbeddedViewRef<unknown>)
      .rootNodes[0] as HTMLElement;

    const toastContainer = document.querySelector('.toast-container');

    toastContainer.append(domElem);

    const toastElem = domElem.querySelector('.toast');
    const toastSlideElem = domElem.querySelector('.toast-slide-container');

    const toast = new bootstrap.Toast(toastElem, {
      autohide,
      animation: false,
    });

    componentRef.instance.self = toast;

    const zone = this.zone;
    toastElem.addEventListener('hide.bs.toast', function hideEvent() {
      toastSlideElem.classList.remove('show');
      toastElem.removeEventListener('hide.bs.toast', hideEvent);
    });

    toastElem.addEventListener('hidden.bs.toast', function hiddenEvent() {
      zone.runOutsideAngular(() => {
        setTimeout(() => {
          domElem.remove();
          componentRef.destroy();
        }, 500);
      });
      toastElem.removeEventListener('hidden.bs.toast', hiddenEvent);
    });

    toastElem.addEventListener('shown.bs.toast', function shownEvent() {
      zone.runOutsideAngular(() => {
        setTimeout(() => {
          toastSlideElem.classList.add('show');
        }, 100);
      });
      toastElem.removeEventListener('shown.bs.toast', shownEvent);
    });
    toast.show();

    return toast;
  }
}
